export default "__VITE_PUBLIC_ASSET__44e7f2dc__"